// Contact/social info is now managed via Django Unfold admin.
// Update these values here when they change; no Firestore dependency.
import { createContext } from 'react'

export const initialContact = {
    FB_LINK:      'https://facebook.com/choicerealestateda',
    IG_LINK:      'https://instagram.com/choicerealestateda',
    LinkedIN_LINK:'https://linkedin.com/company/choicerealestateda',
    address:      '140 Independence Street, Roseau, Dominica',
    email:        'choicerealestateda@gmail.com',
    phone:        '+1 (767) 245-0110',
}

export const ContactContext = createContext({
    value:       initialContact,
    changeValue: () => {},
})
